import React, { useEffect, useState, useRef } from "react";
import { KendoTreeTable } from "../../Kendo/kendo_treetable";
import {
  Button,
  ErrorMsg,
  InfoIcon,
  ValidateForm,
  confirmDelete,
  sessionUser,
} from "../../Util/common";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { generateGuid } from "../../Kendo/kendo_common";
import { toast } from "react-toastify";
import { KendoLoader } from "../../Kendo/kendo_loader";

export const BreadcrumConfig = () => {
  const [error, setError] = useState({});
  const [isAddIcon, setIsAddIcons] = useState(true);
  const modalRef = useRef(null);
  const fileInputRef = useRef(null);
  const [breadcrumCount, setbreadcrumCount] = useState(0);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [Loading, setLoading] = useState(false);

  const [BreadCrum, setBreadCrum] = useState({
    breadcrumId: 0,
    displayinID: 0,
    Image: "",
    OldimagePath: "",
    SortOrder: 0,
    SavedBy: sessionUser(),
    previewUrl: "",
  });

  const [updateBreadCrum, setUpdateBreadCrum] = useState({
    breadcrumId: 0,
    displayinID: 0,
    Image: "",
    OldimagePath: "",
  });

  const [BreadCrumList, setBreadCrumList] = useState([]);
  const [Title, setTitle] = useState("");

  const Parentscolumns = [
    {
      field: "displayedInID",
      filterable: false,
      hidden: true,
    },
    {
      field: "eventName",
      title: "Displayed In",
    },
  ];

  const childColumn = [
    {
      field: "breadcrumId",
      hidden: true,
    },
    {
      field: "displayedInID",
      hidden: true,
    },
    {
      field: "sortOrderId",
      hidden: true,
    },
    {
      template: function (e) {
        if (e.imagePath) {
          return `<img src="${ImageURL}${e.imagePath}" width="40px" height="40px" />`;
        }
        return "";
      },

      title: "Image",
      width: 50,
    },
  ];

  const onValidation = (name, val) => {
    setError((prevErr) => ({
      ...prevErr,
      [name]: !val || val.trim() === "",
    }));
  };

  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    setBreadCrum({
      breadcrumId: 0,
      displayinID: 0,
      Image: "",
      OldimagePath: "",
    });
    setError({});
    setBreadCrumList([]);
    setIsAddIcons(true);
    setIsButtonVisible(true);
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = null;
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;
    let oversize = false;
    oversize = BreadCrum.Image?.size > maxSizeInBytes;

    var err = ValidateForm(e);
    let temp;
    if (err) {
      setError(err);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: oversize,
      }));
      return;
    } else if (!oversize) {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
      }));
      setError({ EmptyList: false });
      temp = [{ ...BreadCrum, guid: generateGuid() }];
      let temp1 = { ...BreadCrum, guid: generateGuid() };
      setBreadCrum(temp1);
      setBreadCrumList([...BreadCrumList, BreadCrum]);
      setBreadCrum((prev) => ({
        ...prev,
        Image: "",
        previewUrl: "",
      }));
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
    } else if (oversize) {
      return;
    }

    if (temp.length === 0) {
      setError({ EmptyList: true });
    } else {
      setLoading(true);
      try {
        const formData = new FormData();
        temp.forEach((breadcrum, index) => {
          formData.append(
            `breadcrumModel[${index}].BreadcrumId`,
            breadcrum.breadcrumId
          );
          formData.append(
            `breadcrumModel[${index}].DisplayedInID`,
            breadcrum.displayinID || ""
          );
          formData.append(
            `breadcrumModel[${index}].SavedBy`,
            sessionUser() || ""
          );
          if (breadcrum.Image) {
            formData.append(`breadcrumModel[${index}].Image`, breadcrum.Image);
          }
        });
        await corepost("Breadcrum/InsertUpdateBreadcrum", formData);

        $("#Add_CommonBanner").modal("hide");
        clearForm();
        refreshChildGrd();
      } catch (error) {
        console.error(error);
      }
    }
  };

  const onEditClick = async (e) => {
    try {
      let data = await corefetch(
        `Breadcrum/GetBreadcrumCount?displayedInId=${e.displayedInID}`
      );

      if (data && data.breadcrumCount !== undefined) {
        const breadcrumCount = data.breadcrumCount;
        setbreadcrumCount(breadcrumCount);
        if (breadcrumCount >= 1) {
          toast.error("Breadcrumb limit has been exceeded.");
        } else {
          const eventName = e.eventName;
          setTitle(eventName);

          let temp = BreadCrum;
          BreadCrum.displayinID = e.displayedInID;
          setBreadCrum(temp);

          const modal = new bootstrap.Modal(
            document.getElementById("Add_CommonBanner")
          );
          modal.show();
        }
      } else {
        console.error(
          "Failed to fetch banner count or received an invalid response."
        );
      }
    } catch (error) {
      console.error("Error fetching banner count:", error);
    }
  };

  const refreshChildGrd = () => {
    $(`#reload-CommonBannerTreetable`)
      .next()
      .find(".k-master-row")
      .each(function (index) {
        if ($(this).find("td:first").find("a:first").hasClass("k-i-collapse")) {
          $(this).next().find(".btn-refresh:first").click();
        }
      });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const hasAvifFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (hasAvifFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (!file) {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
        ValidFile: false,
      }));
      setBreadCrum((prev) => ({
        ...prev,
        Image: "",
      }));
      onValidation("Image", e.target.value);
      return;
    }

    if (file && file.type.startsWith("image/")) {
      setError({ ...error, ValidFile: false });

      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        InValidFileSize: isFileTooLarge,
      }));

      if (isFileTooLarge) {
        setBreadCrum((prev) => ({
          ...prev,
          Image: file,
        }));
      } else {
        let temp = BreadCrum;
        temp.Image = file;

        const reader = new FileReader();
        reader.onloadend = () => {
          setBreadCrum((prev) => ({
            ...prev,
            previewUrl: reader.result,
          }));
        };
        reader.readAsDataURL(file);

        setBreadCrum(temp);
        document.getElementById("image-name").value = file.name;
      }

      onValidation("Image", e.target.value);
    } else {
      e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        InValidFileSize: false,
      }));
      setBreadCrum((prev) => ({
        ...prev,
        Image: "",
      }));
    }
  };

  const UpdatehandleFileChange = (e) => {
    const file = e.target.files[0];
    const hasAvifFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (hasAvifFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (!file) {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
        ValidFile: false,
      }));
      setUpdateBreadCrum((prev) => ({
        ...prev,
        Image: "",
      }));
      onValidation("Image", e.target.value);
      return;
    }

    if (file && file.type.startsWith("image/")) {
      setError({ ...error, ValidFile: false });

      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        InValidFileSize: isFileTooLarge,
      }));

      if (isFileTooLarge) {
        setUpdateBreadCrum((prev) => ({
          ...prev,
          Image: file,
        }));
      } else {
        let temp = updateBreadCrum;
        temp.Image = file;

        const reader = new FileReader();
        reader.onloadend = () => {
          setUpdateBreadCrum((prev) => ({
            ...prev,
            previewUrl: reader.result,
          }));
        };
        reader.readAsDataURL(file);

        setUpdateBreadCrum(temp);
        document.getElementById("image-name").value = file.name;
      }

      onValidation("Image", e.target.value);
    } else {
      e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        InValidFileSize: false,
      }));
      setUpdateBreadCrum((prev) => ({
        ...prev,
        Image: "",
      }));
    }
  };

  const handleFunctionEditClick = (e) => {
    setUpdateBreadCrum({
      breadcrumId: e.child.breadcrumId,
      displayinID: e.child.displayedInID,
      Image: e.child.imagePath,
      OldimagePath: e.child.imagePath,
    });
    setIsAddIcons(false);
    $("#update_CommonBanner").modal("show");
  };

  const onUpdate = async (e) => {
    e.preventDefault();
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;
    let oversize = false;
    oversize = updateBreadCrum.Image?.size > maxSizeInBytes;
    var err = ValidateForm(e);
    if (err) {
      setError(err);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: oversize,
      }));
    } else if (!oversize) {
      setLoading(true);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
      }));
      try {
        const formData = new FormData();
        const breadcrums = [updateBreadCrum];

        breadcrums.forEach((breadcrum, index) => {
          formData.append(`[${index}].BreadcrumId`, breadcrum.breadcrumId);
          formData.append(`[${index}].DisplayedInID`, breadcrum.displayinID);
          formData.append(`[${index}].SavedBy`, sessionUser());
          formData.append(`[${index}].OldImagePath`, breadcrum.OldimagePath);
          if (breadcrum.Image) {
            formData.append(`[${index}].Image`, breadcrum.Image);
          }
        });
        await corepost("Breadcrum/InsertUpdateBreadcrum", formData);

        $("#update_CommonBanner").modal("hide");
        clearForm();
        refreshChildGrd();
      } catch (error) {
        console.error(error);
      }
    } else {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: true,
      }));
    }
  };

  const handleDeleteClick = async (e) => {
    const onDelete = async () => {
      let SavedBy = sessionUser();
      await corefetch(
        `Breadcrum/DeleteBreadcrum?id=${e.breadcrumId}&DeletedBy=${SavedBy}`,
        true,
        false,
        true
      );
      refreshChildGrd();
    };
    confirmDelete(onDelete);
  };

  return (
    <div className="col-auto ms-auto">
      <KendoTreeTable
        name={"CommonBannerTreetable"}
        parentTableUrl={CorebaseURL + "Breadcrum/DisplayBreadcrumDetails"}
        parentTableColumns={Parentscolumns}
        childTableUrl={
          CorebaseURL +
          "Breadcrum/GetBreadcrumDetailsByID?displayedinID={displayedInID}"
        }
        childTableColumns={childColumn}
        onParentEditClick={onEditClick}
        showParentOptions={true}
        showParentDelete={false}
        showChildOptions={true}
        showChildDelete={true}
        onChildEditClick={handleFunctionEditClick}
        onChildDeleteClick={handleDeleteClick}
        refreshWhen={BreadCrumList.length}
      />

      {/* Add CommonBanner Modal */}
      <div
        className="modal custom-modal fade"
        id="Add_CommonBanner"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={{ width: "900px" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{Title}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={clearForm}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="subfun-form" onSubmit={onSubmit}>
                <input
                  type="hidden"
                  name="breadcrumId"
                  value={BreadCrum.breadcrumId || 0}
                />
                <input
                  type="hidden"
                  name="displayinID"
                  value={BreadCrum.displayinID || 0}
                />
                <div className="row">
                  <div className="col-md-10">
                    <label className="form-label">
                      Breadcrumb Image <span className="text-danger">*</span>
                      <InfoIcon
                        content="Kindly Upload a Light Color Landscape Images for Optimal Display.;
                      Kindly upload an Image within 500KB size; 
                      Please upload the image in JPEG, JPG or PNG format."
                      />
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      ref={fileInputRef}
                      name="file"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                    {error.Image && <ErrorMsg text="Image is required" />}
                    {error.ValidFile && (
                      <ErrorMsg text="please upload Image file only" />
                    )}
                    {error.EmptyList && (
                      <ErrorMsg text={"Please add at least one Breadcrum"} />
                    )}
                    {error.InValidFileSize && (
                      <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
                    )}
                  </div>

                  <div className="row mt-1 mb-3">
                    {BreadCrum.OldimagePath && BreadCrum.breadcrumId > 0 && (
                      <div
                        style={{
                          width: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <a
                          href={`${ImageURL}${BreadCrum.OldimagePath}`}
                          target="_blank"
                          style={{
                            textDecoration: "underline",
                            fontSize: "13px",
                          }}
                        >
                          {BreadCrum.OldimagePath.split("/").pop()}
                        </a>
                      </div>
                    )}
                    <input
                      type="hidden"
                      name="Image"
                      id="image"
                      data-required="true"
                      value={BreadCrum.Image || ""}
                    />
                    <input
                      type="hidden"
                      name="OldimagePath"
                      value={BreadCrum.OldimagePath}
                    />
                  </div>
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end btn-mt">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      dataBsDismiss={"modal"}
                      onClick={clearForm}
                    />
                    <Button name={"Save"} />
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Update Common Banner Modal --> */}
      <div
        className="modal custom-modal fade"
        id="update_CommonBanner"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={clearForm}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="subUpdateCBanner-form" onSubmit={onUpdate}>
                <div className="row">
                  <input
                    type="hidden"
                    name="breadcrumId"
                    value={updateBreadCrum.breadcrumId}
                  />
                  <input
                    type="hidden"
                    name="displayinID"
                    value={updateBreadCrum.displayinID}
                  />
                  <div className="row">
                    <div className="col-md-10">
                      <label className="form-label">
                        Breadcrumb Image <span className="text-danger">*</span>
                        <InfoIcon
                          content="Kindly Upload a Light Color Landscape Images for Optimal Display.;
                          Kindly upload an Image within 500KB size;
                        Please upload the image in JPEG, JPG or PNG format."
                        />
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        ref={fileInputRef}
                        name="file"
                        accept="image/*"
                        onChange={UpdatehandleFileChange}
                      />
                      {error.Image && <ErrorMsg text="Image is required" />}
                      {error.ValidFile && (
                        <ErrorMsg text="please upload Image file only" />
                      )}
                      {error.InValidFileSize && (
                        <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
                      )}
                    </div>
                    <div className="row mt-1 mb-3">
                      {updateBreadCrum.OldimagePath &&
                        updateBreadCrum.breadcrumId > 0 && (
                          <div
                            style={{
                              width: "100%",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <a
                              href={`${ImageURL}${updateBreadCrum.OldimagePath}`}
                              target="_blank"
                              style={{
                                textDecoration: "underline",
                                fontSize: "13px",
                              }}
                            >
                              {updateBreadCrum.OldimagePath.split("/").pop()}
                            </a>
                          </div>
                        )}
                      <input
                        type="hidden"
                        name="Image"
                        id="image-name"
                        data-required="true"
                        value={updateBreadCrum.Image || ""}
                      />
                      <input
                        type="hidden"
                        name="OldimagePath"
                        value={updateBreadCrum.OldimagePath}
                      />
                    </div>
                  </div>
                  {Loading ? (
                    <KendoLoader className="d-flex justify-content-end align-items-center" />
                  ) : (
                    <div className="text-end btn-mt">
                      <Button
                        name={"Cancel"}
                        isCancelButton={true}
                        id="ballroom-ballfun-cancel"
                        dataBsDismiss={"modal"}
                        onClick={() => {
                          clearForm();
                        }}
                      />
                      <Button name={"Update"} />
                    </div>
                  )}
                  <button
                    type="button"
                    id="hide"
                    style={{ display: "none" }}
                    data-bs-dismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  ></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
